module.exports = __webpack_public_path__ + "assets-cabinet/img/a_file_download.ab6895fc.svg";